<template>
    <div class="popup account-dialog account-dialog--password-set">
        <van-popup :value="show" @click-overlay="close">
            <div class="content">
                <div class="header">
                    <div><AccountUiIcon name="lock" /><span>{{ $t("withdrawPwd.title") }}</span></div>
                    <div class="close"><AccountUiIcon name="close" @click.native="close" /></div>
                </div>
                <div class="info_box">
                    <div class="topTips" v-if="!isFrirstSet">{{ $t('withdrawPwd.withdrawPwdTips1') }}</div>
                    <a-form-model ref="ruleForm" :model="formData" :rules="formRules" @submit.native.prevent>
                        <a-form-model-item ref="pwd1" label="" prop="pwd1">
                            <div class="label">
                                {{ $t('withdrawPwd.withdrawPwdLabel1') }}
                                <div class="eyes" @click.stop="isPwd1Dot = !isPwd1Dot">
                                    <AccountUiIcon :name="isPwd1Dot ? 'hidden' : 'visible'" />
                                </div>
                            </div>
                            <code-input v-model="formData.pwd1" mode="box" :space="0" :maxlength="6" hairline :color="primaryColor"
                                :dot="isPwd1Dot" size="48"></code-input>
                        </a-form-model-item>
                        <a-form-model-item ref="pwd2" label="" prop="pwd2">
                            <div class="label">
                                {{ $t('withdrawPwd.withdrawPwdLabel2') }}
                                <div class="eyes" @click.stop="isPwd2Dot = !isPwd2Dot">
                                    <AccountUiIcon :name="isPwd2Dot ? 'hidden' : 'visible'" />
                                </div>
                            </div>
                            <code-input v-model="formData.pwd2" mode="box" :space="0" :maxlength="6" hairline :color="primaryColor"
                                :dot="isPwd2Dot" size="48"></code-input>
                        </a-form-model-item>
                    </a-form-model>
                    <div class="botTips">{{ $t('withdrawPwd.withdrawPwdTips3') }}</div>
                </div>
                <div class="action_btn" @click="handleSubmit">
                    <span>{{ $t("lang.confirm") }}</span>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import AccountUiIcon from '@/components/account-dialogs/AccountUiIcon.vue'
import { mapState } from 'vuex'
import { modifyWithdrawPassword } from '@/api/withdraw'
import { getUserInfo } from '@/api/user'
import { Toast } from 'vant'
import md5 from 'md5'
import codeInput from '@/components/codeInput'
export default {
    name: 'withdrawPwdSet',
    components: { AccountUiIcon, codeInput },
    data() {
        return {
            primaryColor: 'var(--theme-bright-text)',
            formData: {
                pwd1: '',
                pwd2: ''
            },
            formRules: {
                // pwd1: [{
                //     required: true,
                //     message: this.$t('withdrawPwd.PleaseEnterWithdrawalPassword'),
                //     trigger: ['blur', 'change']
                // }, {
                //     pattern: /^(?=.*\d)(?!.*(\d)\1{5}).{6}$/,
                //     transform(value) {
                //         return String(value);
                //     },
                //     message: this.$t('withdrawPwd.notContinuousNumbers'),
                //     trigger: ['blur', 'change']
                // }],
                // pwd2: [{
                //     required: true,
                //     message: this.$t('withdrawPwd.ConfirmWithdrawalPassword'),
                //     trigger: ['blur', 'change']
                // }, {
                //     pattern: /^(?=.*\d)(?!.*(\d)\1{5}).{6}$/,
                //     transform(value) {
                //         return String(value);
                //     },
                //     message: this.$t('withdrawPwd.notContinuousNumbers'),
                //     trigger: ['blur', 'change']
                // }]
            },
            isPwd1Dot: true,
            isPwd2Dot: true,
            pageType: ''
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        show: {
            get() {
                return this.$store.getters.isShowWithdrawPwdSetPopup
            },
            set(val) {
                return val
            }
        },
        isFrirstSet() {
            const uInfo = this.$store.getters.userInfo
            return uInfo && uInfo.existsWithdrawPassword
        }
    },
    methods: {
        close() {
            this.formData = {
                pwd1: '',
                pwd2: ''
            }
            this.$store.dispatch('user/setIsShowWithdrawPwdSetPopup', false)
        },
        handleSubmit() {
            const that = this
            const formdata = that.formData
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if (!formdata.pwd1) {
                        Toast(this.$t('withdrawPwd.PleaseEnterWithdrawalPassword'))
                        return
                    }
                    const pwdReg = /^(?=.*\d)(?!.*(\d)\1{5}).{6}$/
                    if (!pwdReg.test(formdata.pwd1)) {
                        Toast(that.$t('withdrawPwd.notContinuousNumbers'))
                        return
                    }
                    if (!formdata.pwd2) {
                        Toast(this.$t('withdrawPwd.ConfirmWithdrawalPassword'))
                        return
                    }
                    if (!pwdReg.test(formdata.pwd2)) {
                        Toast(that.$t('withdrawPwd.notContinuousNumbers'))
                        return
                    }
                    if (formdata.pwd1 !== formdata.pwd2) {
                        Toast(this.$t('withdrawPwd.InputInconsistentWithdrawPassword'))
                        return
                    }
                    const params = {
                        withdrawPassword: md5(formdata.pwd1),
                        withdrawPasswordVerify: md5(formdata.pwd2)
                    }
                    modifyWithdrawPassword(params).then((res) => {
                        if (res.code) return
                        getUserInfo().then((uInfo) => {
                            if (uInfo.code) return
                            that.$store.dispatch('user/saveUserInfo', uInfo.result)
                        })
                        that.close()
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/account-dialogs.scss';
</style>
